/* ═══════════ VOVANGA STUDIO — global theme JS ═══════════ */
(function(){
  'use strict';
  const $  = (s,r)=> (r||document).querySelector(s);
  const $$ = (s,r)=> Array.from((r||document).querySelectorAll(s));
  const cfg = window.VV_CONFIG || {};
  const ROUTES = cfg.routes || {};
  const MONEY_FORMAT = cfg.moneyFormat || '€{{amount}}';

  /* ---------- money ---------- */
  function money(cents){
    const v = cents/100;
    const str = v.toLocaleString(undefined,{minimumFractionDigits:(v%1===0?0:2),maximumFractionDigits:2});
    return MONEY_FORMAT.replace(/\{\{\s*amount(_no_decimals)?[^}]*\}\}/g,str);
  }
  window.vvMoney = money;

  /* ---------- toast ---------- */
  let toastEl, toastT;
  function toast(msg){
    if(!toastEl){ toastEl=document.createElement('div'); toastEl.className='vv-toast'; document.body.appendChild(toastEl); }
    toastEl.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'+msg;
    toastEl.classList.add('show'); clearTimeout(toastT); toastT=setTimeout(()=>toastEl.classList.remove('show'),2600);
  }
  window.vvToast = toast;

  /* ---------- age gate ---------- */
  function initGate(){
    const g = $('#vv-gate'); if(!g) return;
    if(sessionStorage.getItem('vv_age')) g.classList.add('hidden');
    const enter = $('#vv-gate-enter');
    if(enter) enter.addEventListener('click',()=>{ sessionStorage.setItem('vv_age','1'); g.classList.add('hidden'); });
  }

  /* ---------- ticker ---------- */
  function initTicker(){
    const t = $('#vv-ticker'); if(!t) return;
    const raw = t.getAttribute('data-msgs')||'';
    const msgs = raw.split('|').map(s=>s.trim()).filter(Boolean);
    if(!msgs.length) return;
    let h='';
    for(let r=0;r<2;r++) msgs.forEach(m=>{ h+='<span class="vv-ticker-item">'+m+'</span><span class="vv-ticker-item vv-ticker-sep">✦</span>'; });
    t.innerHTML=h;
  }

  /* ---------- nav scroll ---------- */
  function initNav(){
    const nav = $('#vv-nav'); if(!nav) return;
    if(nav.dataset.solid==='true'){ nav.classList.add('solid'); return; }
    const onScroll=()=>nav.classList.toggle('scrolled',window.scrollY>60);
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  }

  /* ---------- drawers / overlay ---------- */
  function overlay(){ return $('#vv-overlay'); }
  function anyDrawer(){ return ($('#vv-menu')&&$('#vv-menu').classList.contains('open'))||($('#vv-cart')&&$('#vv-cart').classList.contains('open')); }
  function openMenu(){ closeAll(true); const m=$('#vv-menu'); if(m){ m.classList.add('open'); overlay().classList.add('open'); document.body.classList.add('vv-locked'); } }
  function openCart(){ closeAll(true); refreshCart(); const c=$('#vv-cart'); if(c){ c.classList.add('open'); overlay().classList.add('open'); document.body.classList.add('vv-locked'); } }
  function closeAll(keep){
    ['#vv-menu','#vv-cart'].forEach(s=>{ const el=$(s); if(el) el.classList.remove('open'); });
    if(overlay()) overlay().classList.remove('open');
    closeSearch();
    const modalOpen = $('#vv-modal')&&$('#vv-modal').classList.contains('open');
    if(!keep && !modalOpen) document.body.classList.remove('vv-locked');
  }
  window.vvOpenMenu=openMenu; window.vvOpenCart=openCart; window.vvCloseAll=closeAll;

  /* ---------- CART (Ajax) ---------- */
  function addToCart(id,qty,cb){
    fetch((ROUTES.cartAdd||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty||1}]})})
      .then(r=>r.json()).then(d=>{ if(d.status){ toast(d.description||'Could not add'); return; } refreshCart(); if(cb)cb(); })
      .catch(()=>toast('Could not add — try again'));
  }
  function changeLine(key,qty){
    fetch((ROUTES.cartChange||'/cart/change')+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(r=>r.json()).then(renderCart);
  }
  function refreshCart(){ fetch((ROUTES.cart||'/cart')+'.js').then(r=>r.json()).then(renderCart).catch(()=>{}); }
  function renderCart(c){
    if(!c) return;
    const n=c.item_count;
    $$('.vv-cart-badge').forEach(b=>{ b.textContent=n; b.classList.toggle('empty',n===0); });
    const cl=$('#vv-cart-count'); if(cl) cl.textContent='('+n+')';
    const box=$('#vv-cart-items'), foot=$('#vv-cart-foot');
    if(!box) return;
    if(!c.items.length){
      box.innerHTML='<div class="vv-cart-empty"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Your cart is empty.</p><a class="vv-btn" href="'+(ROUTES.allProducts||'/collections/all')+'">Browse the catalogue</a></div>';
      if(foot) foot.style.display='none'; return;
    }
    if(foot) foot.style.display='block';
    box.innerHTML=c.items.map(it=>{
      const variant = it.variant_title && it.variant_title!=='Default Title' ? it.variant_title : '';
      const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2') : '';
      const thumb = img ? '<img class="vv-cart-thumb" src="'+img+'" alt="">' : '<div class="vv-cart-thumb">'+esc(it.product_title.slice(0,6))+'</div>';
      return '<div class="vv-cart-row">'+thumb+
        '<div class="vv-cart-info"><div class="vv-cart-name">'+esc(it.product_title.toUpperCase())+'</div>'+
        '<div class="vv-cart-variant">'+(variant?esc(variant):'&nbsp;')+'</div>'+
        '<div class="vv-qty"><button data-k="'+it.key+'" data-q="'+(it.quantity-1)+'" aria-label="Decrease">−</button><span>'+it.quantity+'</span><button data-k="'+it.key+'" data-q="'+(it.quantity+1)+'" aria-label="Increase">+</button></div></div>'+
        '<div class="vv-cart-right"><span class="vv-cart-price">'+money(it.final_line_price)+'</span><button class="vv-cart-remove" data-k="'+it.key+'" data-q="0">Remove</button></div></div>';
    }).join('');
    const tot=$('#vv-cart-total'); if(tot) tot.textContent=money(c.total_price);
    $$('.vv-qty button, .vv-cart-remove',box).forEach(b=>b.addEventListener('click',()=>changeLine(b.dataset.k,+b.dataset.q)));
  }
  window.vvAddToCart=addToCart; window.vvRefreshCart=refreshCart;

  /* ---------- WISHLIST ---------- */
  let wishlist=[];
  try{ wishlist=JSON.parse(localStorage.getItem('vv_wish')||'[]'); }catch(e){ wishlist=[]; }
  function saveWish(){ localStorage.setItem('vv_wish',JSON.stringify(wishlist)); paintWish(); }
  function paintWish(){
    $$('.vv-wish-badge').forEach(b=>{ b.textContent=wishlist.length; b.classList.toggle('empty',wishlist.length===0); });
    $$('.vv-card-wish, .vv-wishbtn').forEach(w=>{
      const h=w.dataset.handle; if(!h) return;
      const on=wishlist.includes(h);
      w.classList.toggle('active',on);
      const svg=w.querySelector('svg'); if(svg) svg.setAttribute('fill',on?'currentColor':'none');
    });
  }
  function toggleWish(h){
    if(wishlist.includes(h)) wishlist=wishlist.filter(x=>x!==h);
    else { wishlist.push(h); toast('Added to wishlist'); }
    saveWish();
  }
  window.vvToggleWish=function(e,h){ if(e)e.stopPropagation(); toggleWish(h); if(modalHandle===h) renderModal(); };

  /* ---------- QUICK VIEW MODAL ---------- */
  let modalHandle=null, modalData=null, modalSel=[];
  function openProduct(handle){
    fetch('/products/'+handle+'.js').then(r=>r.json()).then(p=>{
      modalHandle=handle; modalData=p;
      const def = p.variants.find(v=>v.available)||p.variants[0];
      modalSel = def ? def.options.slice() : [];
      renderModal();
      $('#vv-modal').classList.add('open'); document.body.classList.add('vv-locked');
    }).catch(()=>toast('Could not load product'));
  }
  function currentVariant(){
    return modalData.variants.find(v=>v.options.every((o,i)=>o===modalSel[i]));
  }
  function optAvailable(oi,val){
    return modalData.variants.some(v=>v.available && v.options[oi]===val &&
      v.options.every((o,i)=> i===oi ? true : o===modalSel[i]));
  }
  function seriesOf(p){
    // first non-generic collection title isn't in /products.js; use type or vendor
    return p.type || p.vendor || 'Vovanga';
  }
  /* finish/colour name -> hex (for swatches). Extend freely. */
  const SWATCHES={'silver matte':'#b8b8bd','silver':'#c3c3c8','gray':'#9a9a9f','grey':'#9a9a9f','bone':'#e6ddca','charcoal':'#2c2c30','black':'#161616','red':'#b3122a','white':'#f0f0f0','gold':'#c9a06a','bronze':'#9c7a4d'};
  /* "painted" / "hand-painted" / "color" → multicolour swatch */
  const PAINTED_GRADIENT='conic-gradient(from 210deg,#c0392b,#d68910,#27ae60,#2980b9,#8e44ad,#c0392b)';
  function isSwatchOption(name){ return /finish|colou?r|paint/i.test(name); }
  function isPainted(val){ return /paint|multi|colou?r/i.test(String(val)); }
  function optButton(name,oi,val,sel,avail){
    const cls='vv-opt-btn'+(sel?' active':'')+(avail?'':' sold');
    const dis=avail?'':'disabled';
    if(isSwatchOption(name)){
      const bg = isPainted(val) ? PAINTED_GRADIENT : (SWATCHES[String(val).toLowerCase()]||'#888');
      return '<button class="'+cls+' swatch" '+dis+' data-oi="'+oi+'" data-val="'+esc(val)+'" title="'+esc(val)+'" aria-label="'+esc(val)+'" style="--sw:'+bg+'"></button>';
    }
    return '<button class="'+cls+'" '+dis+' data-oi="'+oi+'" data-val="'+esc(val)+'">'+esc(val)+'</button>';
  }
  function renderModal(){
    const p=modalData;
    const media=$('#vv-modal-media');
    const img = p.featured_image || (p.images&&p.images[0]);
    media.innerHTML = img ? '<img src="'+img+'" alt="'+esc(p.title)+'">' : '<div class="vv-ed-ph">'+esc(p.title)+'</div>';
    const v=currentVariant();
    const price = v ? money(v.price) : (p.price_varies?'—':money(p.price));
    let optsHtml='';
    if(!(p.options.length===1 && p.options[0]==='Title')){
      optsHtml = p.options.map((name,oi)=>{
        const values=[...new Set(p.variants.map(v=>v.options[oi]))];
        const btns=values.map(val=>{
          const sel=modalSel[oi]===val, avail=optAvailable(oi,val);
          return optButton(name,oi,val,sel,avail);
        }).join('');
        return '<div class="vv-opt"><div class="vv-opt-label">'+esc(name)+' <span>'+esc(modalSel[oi]||'')+'</span></div><div class="vv-opt-row">'+btns+'</div></div>';
      }).join('');
    }
    const onWish=wishlist.includes(p.handle);
    const canAdd = v && v.available;
    const desc = (p.description||'').replace(/<[^>]+>/g,' ').replace(/\s+/g,' ').trim().split(' ').slice(0,40).join(' ');
    $('#vv-modal-content').innerHTML=
      '<div class="vv-modal-series">'+esc(seriesOf(p))+'</div>'+
      '<h2 class="vv-modal-name">'+esc(p.title.toUpperCase())+'</h2>'+
      '<div class="vv-modal-price" id="vv-modal-price">'+price+'</div>'+
      '<p class="vv-modal-desc">'+esc(desc)+'</p>'+
      '<a class="vv-modal-view" href="'+p.url+'">View full details →</a>'+
      optsHtml+
      '<div class="vv-modal-actions">'+
        '<button class="vv-add" id="vv-modal-add" '+(canAdd?'':'disabled')+'>'+(canAdd?('Add to cart — '+price):'Sold out')+'</button>'+
        '<button class="vv-wishbtn'+(onWish?' active':'')+'" data-handle="'+p.handle+'" id="vv-modal-wish" aria-label="Wishlist"><svg width="18" height="18" viewBox="0 0 24 24" fill="'+(onWish?'currentColor':'none')+'" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></button>'+
      '</div>'+
      '<div class="vv-modal-meta"><div><strong>Made to order</strong>Ships 2–3 weeks</div><div><strong>Hand-finished</strong>In Vienna</div><div><strong>Secure checkout</strong>15+ methods</div></div>';
    $$('#vv-modal-content .vv-opt-btn').forEach(b=>{ if(!b.disabled) b.addEventListener('click',()=>{ modalSel[+b.dataset.oi]=b.dataset.val; renderModal(); }); });
    const addBtn=$('#vv-modal-add'); if(addBtn&&canAdd) addBtn.addEventListener('click',()=>{ addToCart(v.id,1,()=>{ closeModal(); openCart(); toast(p.title+' added to cart'); }); });
    const wb=$('#vv-modal-wish'); if(wb) wb.addEventListener('click',()=>{ toggleWish(p.handle); renderModal(); });
  }
  function closeModal(){ const m=$('#vv-modal'); if(m) m.classList.remove('open'); if(!anyDrawer()) document.body.classList.remove('vv-locked'); }
  window.vvOpenProduct=openProduct; window.vvCloseModal=closeModal;

  /* ---------- SEARCH (predictive) ---------- */
  let searchT;
  function openSearch(){ const s=$('#vv-search'); if(!s) return; s.classList.add('open'); overlay().classList.add('open'); document.body.classList.add('vv-locked'); setTimeout(()=>{ const i=$('#vv-search-input'); if(i) i.focus(); },300); doSearch(''); }
  function closeSearch(){ const s=$('#vv-search'); if(s) s.classList.remove('open'); }
  function doSearch(q){
    const r=$('#vv-search-results'); if(!r) return;
    q=q.trim();
    if(!q){ r.innerHTML='<div style="padding:24px;color:var(--muted);font-size:13px;letter-spacing:.05em;">Start typing to search the catalogue…</div>'; return; }
    clearTimeout(searchT);
    searchT=setTimeout(()=>{
      fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8')
        .then(res=>res.json()).then(data=>{
          const items=(data.resources&&data.resources.results&&data.resources.results.products)||[];
          if(!items.length){ r.innerHTML='<div style="padding:24px;color:var(--muted);font-size:14px;">No results for “'+esc(q)+'”.</div>'; return; }
          r.innerHTML=items.map(p=>{
            const img=p.featured_image&&p.featured_image.url?p.featured_image.url:(p.image||'');
            const thumb=img?'<img class="vv-sr-thumb" src="'+img+'" alt="">':'<div class="vv-sr-thumb"></div>';
            const price=p.price?money(typeof p.price==='string'?Math.round(parseFloat(p.price)*100):p.price):'';
            return '<a class="vv-sr" href="'+p.url+'">'+thumb+'<div><div class="vv-sr-name">'+esc(p.title)+'</div><div class="vv-sr-meta">'+esc(p.type||'')+(price?' · '+price:'')+'</div></div></a>';
          }).join('');
        }).catch(()=>{ r.innerHTML='<div style="padding:24px;color:var(--muted);">Search unavailable.</div>'; });
    },180);
  }
  window.vvOpenSearch=openSearch; window.vvCloseSearch=closeSearch;

  /* ---------- HOME catalogue filter ---------- */
  function initHomeFilter(){
    const grid=$('#vv-grid'); if(!grid) return;
    let activeFilter='all';
    const sortSel=$('#vv-sort');
    function apply(){
      const cards=$$('.vv-card',grid);
      let shown=0;
      cards.forEach(c=>{
        let ok=true;
        if(activeFilter==='new') ok=(c.dataset.tags||'').includes('new');
        else if(activeFilter==='bestseller') ok=(c.dataset.tags||'').includes('bestseller');
        else if(activeFilter!=='all') ok=(c.dataset.collections||'').split(' ').includes(activeFilter);
        c.classList.toggle('hide',!ok); if(ok) shown++;
      });
      if(sortSel){
        const s=sortSel.value, vis=cards.filter(c=>!c.classList.contains('hide'));
        if(s==='price-asc') vis.sort((a,b)=>(+a.dataset.price)-(+b.dataset.price));
        else if(s==='price-desc') vis.sort((a,b)=>(+b.dataset.price)-(+a.dataset.price));
        vis.forEach(c=>grid.appendChild(c));
      }
      const empty=$('#vv-grid-empty'); if(empty) empty.style.display=shown?'none':'block';
      const cc=$('#vv-cat-count'); if(cc) cc.textContent=shown;
    }
    window.vvFilter=function(f){
      activeFilter=f;
      $$('.vv-filter').forEach(b=>b.classList.toggle('active',b.dataset.f===f));
      apply();
      const cat=$('#vv-catalogue'); if(cat) cat.scrollIntoView({behavior:'smooth'});
      closeAll();
    };
    if(sortSel) sortSel.addEventListener('change',apply);
    $$('.vv-filter').forEach(b=>b.addEventListener('click',()=>window.vvFilter(b.dataset.f)));
    apply();
  }

  /* ---------- PDP (product page) ---------- */
  function initPDP(){
    const pdp=$('#vv-pdp'); if(!pdp) return;
    let data=null;
    try{ data=JSON.parse($('#vv-pdp-data').textContent); }catch(e){ return; }
    let sel = (data.variants.find(v=>v.available)||data.variants[0]).options.slice();

    // gallery
    $$('.vv-pdp-thumb').forEach(t=>t.addEventListener('click',()=>{
      $$('.vv-pdp-thumb').forEach(x=>x.classList.remove('active')); t.classList.add('active');
      const main=$('#vv-pdp-main-img'); if(main) main.src=t.dataset.full;
    }));

    function curVar(){ return data.variants.find(v=>v.options.every((o,i)=>o===sel[i])); }
    function avail(oi,val){ return data.variants.some(v=>v.available&&v.options[oi]===val&&v.options.every((o,i)=>i===oi?true:o===sel[i])); }
    function renderOpts(){
      const wrap=$('#vv-pdp-opts'); if(!wrap) return;
      if(data.options.length===1 && data.options[0].name==='Title'){ wrap.innerHTML=''; return; }
      wrap.innerHTML=data.options.map((o,oi)=>{
        const btns=o.values.map(val=>{
          const s=sel[oi]===val, a=avail(oi,val);
          return optButton(o.name,oi,val,s,a);
        }).join('');
        return '<div class="vv-opt"><div class="vv-opt-label">'+esc(o.name)+' <span>'+esc(sel[oi]||'')+'</span></div><div class="vv-opt-row">'+btns+'</div></div>';
      }).join('');
      $$('.vv-opt-btn',wrap).forEach(b=>{ if(!b.disabled) b.addEventListener('click',()=>{ sel[+b.dataset.oi]=b.dataset.val; update(); }); });
    }
    function update(){
      renderOpts();
      const v=curVar();
      const priceEl=$('#vv-pdp-price-val');
      const addBtn=$('#vv-pdp-add');
      if(v){
        let html=money(v.price);
        if(v.compare_at_price && v.compare_at_price>v.price) html='<span class="was">'+money(v.compare_at_price)+'</span>'+html;
        if(priceEl) priceEl.innerHTML=html;
        if(addBtn){ addBtn.disabled=!v.available; addBtn.textContent=v.available?('Add to cart — '+money(v.price)):'Sold out'; addBtn.dataset.vid=v.id; }
      } else {
        if(addBtn){ addBtn.disabled=true; addBtn.textContent='Unavailable'; }
      }
    }
    update();
    const addBtn=$('#vv-pdp-add');
    if(addBtn) addBtn.addEventListener('click',()=>{ const v=curVar(); if(v&&v.available) addToCart(v.id,1,()=>{ openCart(); toast(data.title+' added to cart'); }); });
    const wb=$('#vv-pdp-wish'); if(wb) wb.addEventListener('click',()=>{ toggleWish(data.handle); });
    // accordions
    $$('.vv-acc-head',pdp).forEach(h=>h.addEventListener('click',()=>h.closest('.vv-acc-item').classList.toggle('open')));
  }

  /* ---------- helpers ---------- */
  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])); }

  /* ---------- global delegation ---------- */
  document.addEventListener('click',e=>{
    const a=e.target.closest('[data-vv]');
    if(!a) return;
    const act=a.getAttribute('data-vv');
    if(act==='menu'){ e.preventDefault(); openMenu(); }
    else if(act==='cart'){ e.preventDefault(); openCart(); }
    else if(act==='search'){ e.preventDefault(); openSearch(); }
    else if(act==='close'){ e.preventDefault(); closeAll(); }
    else if(act==='close-search'){ e.preventDefault(); closeSearch(); }
    else if(act==='close-modal'){ e.preventDefault(); closeModal(); }
    else if(act==='quick'){ e.preventDefault(); openProduct(a.dataset.handle); }
    else if(act==='wish'){ e.preventDefault(); e.stopPropagation(); toggleWish(a.dataset.handle); }
    else if(act==='filter'){ e.preventDefault(); if(window.vvFilter) window.vvFilter(a.dataset.f); else window.location.href=(ROUTES.allProducts||'/collections/all'); }
  });
  document.addEventListener('keydown',e=>{ if(e.key==='Escape'){ closeModal(); closeAll(); } });
  const si=document.getElementById('vv-search-input'); // bound after DOM
  document.addEventListener('input',e=>{ if(e.target.id==='vv-search-input') doSearch(e.target.value); });

  /* ---------- HERO SLIDER ---------- */
  function initSlider(){
    const slider=$('#vv-slider'); if(!slider) return;
    const slides=$$('.vv-slide',slider);
    if(slides.length<=1){ if(slides[0]) slides[0].classList.add('active'); return; }
    const dots=$$('.vv-dot',slider);
    const dur=(parseInt(slider.dataset.dur,10)||6)*1000;
    let cur=0, timer=null;
    const cntCur=$('#vv-slide-cur');
    function go(n){
      cur=(n+slides.length)%slides.length;
      slides.forEach((s,i)=>s.classList.toggle('active',i===cur));
      dots.forEach((d,i)=>d.classList.toggle('active',i===cur));
      if(cntCur) cntCur.textContent=String(cur+1).padStart(2,'0');
      restart();
    }
    function next(){ go(cur+1); }
    function prev(){ go(cur-1); }
    function restart(){ if(timer) clearTimeout(timer); timer=setTimeout(next,dur); }
    $$('.vv-slider-arrow',slider).forEach(a=>a.addEventListener('click',()=>{ a.dataset.dir==='prev'?prev():next(); }));
    dots.forEach((d,i)=>d.addEventListener('click',()=>go(i)));
    // pause on hover (desktop)
    slider.addEventListener('mouseenter',()=>{ if(timer) clearTimeout(timer); });
    slider.addEventListener('mouseleave',restart);
    // swipe
    let sx=0;
    slider.addEventListener('touchstart',e=>{ sx=e.touches[0].clientX; },{passive:true});
    slider.addEventListener('touchend',e=>{ const dx=e.changedTouches[0].clientX-sx; if(Math.abs(dx)>50){ dx<0?next():prev(); } });
    go(0);
  }

  /* ---------- boot ---------- */
  function boot(){
    initGate(); initTicker(); initNav();
    initSlider(); initHomeFilter(); initPDP();
    paintWish(); refreshCart();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
